// customer data

import React, { useEffect, useRef, useState } from "react";
import ArrowLeft from ".//..//..//..//..//..//assets//images//icons//arrow-left.svg";
import ButtonFluid from "../../../../../components/common/buttons/ButtonFluid";
import BackButton from "../../../../../components/calculator/ConditionLabel/BackButton";
import ButtonOutline from "../../../../../components/common/buttons/ButtonOutline";
import StepBar from "../../../../../components/calculator/Wizard/StepBar";
import CustomerItem from "../../../../../components/calculator/Wizard/CustomerItem";

import RadioButton from "../../../../../components/common/RadioButton/RadioButton";
import TextArea from "../../../../../components/common/TextArea/TextArea";
import CreateCustomerModal from "./CreateCustomerModal";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../constants/Routes";
import CustomerList from "./components/CustomerLIst";
import Swal from "sweetalert2";

import Spinner from "../../../../../components/common/Splnner/Spinner";
import useAuth from "../../../../../hooks/useAuth";
import HttpHelper from "../../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../../constants/API_ROUTES";
import { toast } from "react-toastify";
import ErrorLabel from "../../../../../components/common/label/ErrorLabel";

const UjUgyfelAdatok = () => {
  const customerListRef = useRef(null);
  const [step, setStep] = useState(1);
  const [isDataChanged, setIsDataChanged] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const proposalId = searchParams.get("p-id");
  const [spinnerVisible, setSpinnerVisible] = useState(false);

  const { getAuth, clearAuth } = useAuth();

  const refreshCustomerList = () => {
    if (customerListRef.current) {
      customerListRef.current.fetchCustomers();
    }
  };

  const resetError = () => {
    setFeljegyzesError("");
    setProposalTypeError("");
    setSelectedCustomerError("");
  };

  const getCustomerData = () => {
    setSpinnerVisible(true);
    HttpHelper.GetRequest({
      route: `${API_ROUTES.PR_CUSTOMER_DATA}?proposal_id=${proposalId}`,
      token: getAuth()?.bearerToken,
    })
      .then((data) => {
        if (data.status == 200) {
          const proposal = data?.data?.proposal;
          if (proposal.length > 0) {
            setSelectedCustomer(proposal[0].customer_id);
            setProposalType(proposal[0].proposal_type);
            setFeljegyzes(proposal[0].feljegyzes != null ? proposal[0].feljegyzes : "");
          }

          setSpinnerVisible(false);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        } else {
          toast.error("Unknown server error 1!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Unknown server error 2!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSpinnerVisible(false);
      });
  };

  useEffect(() => {
    getCustomerData();
  }, []);

  const onBackHandler = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You want to go back ? ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Go Back!",
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#8CD4F5",
        cancelButtonColor: "#eee",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          navigate(ROUTES.CAL_LIST);
        }
      });
  };

  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedCustomerError, setSelectedCustomerError] = useState("");
  const [proposalType, setProposalType] = useState("");
  const [proposalTypeError, setProposalTypeError] = useState("");
  const [feljegyzes, setFeljegyzes] = useState("");
  const [feljegyzesError, setFeljegyzesError] = useState("");

  const selectCustomerHandler = (customerId) => {
    setSelectedCustomer(customerId);
  };

  const onNextHandler = () => {
    resetError();
    updateProposal();
  };

  const updateProposal = () => {
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_UPDATE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposalId: proposalId,
        selectedCustomer: selectedCustomer,
        proposalType: proposalType,
        feljegyzes: feljegyzes,
      },
    })
      .then((res) => {
        if (res?.status === 200) {
          toast.success(res?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate(`${ROUTES.CAL_MANAGE_TOUR_PLAN}?p-id=${proposalId}`);
        } else if (res.status === 422) {
          const messages = res.message;
          for (const key in messages) {
            if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
              const errorMessage = messages[key][0];
              if (key === "selectedCustomer") {
                setSelectedCustomerError(errorMessage);
              } else if (key === "proposalType") {
                setProposalTypeError(errorMessage);
              } else if (key === "feljegyzes") {
                setFeljegyzesError(errorMessage);
              }
            }
          }
        } else if (res.status === 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        toast.error("Hiba, javaslat nem lett létrehozva.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <>
      <Spinner spinnerVisible={spinnerVisible}>
        <div className="px-[1rem]  sm:px-[1.875rem] mt-[3rem] gap-3 grid grid-cols-2 md:grid-cols-[10rem_1fr_10rem] grid-rows-2 md:grid-rows-1">
          <div className="col-start-1 col-end-2 row-start-2 row-end-3 md:row-span-1 md:row-end-2 ">
            <div className="max-w-[10rem] me-auto">
              <BackButton icon={ArrowLeft} label={"Vissza"} onClick={onBackHandler} />
            </div>
          </div>
          <div className="w-full col-span-2 md:col-span-1 md:col-end-3 md:col-start-2 ">
            <StepBar currentStepNo={step} />
          </div>
          <div className="col-start-2 col-end-3 row-start-2 row-end-3 md:col-end-4 md:col-start-3 md:row-span-1 md:row-end-2 ">
            <div className="max-w-[10rem] ms-auto">
              {/* <Link to={ROUTES.CAL_MANAGE_TOUR_PLAN}> */}
              <ButtonFluid label={"Mentés"} onClick={onNextHandler} />
              {/* </Link> */}
            </div>
          </div>
        </div>
        {/* Header End */}
        <div className="px-[1rem] sm:px-[5rem] mt-[5.4rem]">
          <div className="flex flex-col gap-10 lg:flex-row">
            <div className="w-full lg:w-1/2 ">
              <h2 className="font-bold font-lato text-[1.5rem] leading-normal  ps-2 pe-4">
                Meglévő ügyfél kiválasztása
              </h2>

              <div>
                <CustomerList
                  ref={customerListRef}
                  selectedCustomer={selectedCustomer}
                  selectCustomer={selectCustomerHandler}
                />
              </div>
              <ErrorLabel id={"customerError"} error={selectedCustomerError} />
              <div className="mt-5 text-end pe-4">
                <CreateCustomerModal refreshCustomerList={refreshCustomerList} />
              </div>
            </div>
            <div className="w-full lg:w-1/2">
              <div className="flex flex-col gap-1 xl:flex-row">
                <div className="w-full p-2 ps-0 xl:w-1/3">
                  <RadioButton
                    label={`Költöztetés`}
                    id={`Költöztetés`}
                    name={`service_type`}
                    value={"Költöztetés"}
                    selectedOption={proposalType}
                    onChange={(e) => {
                      setProposalType(e.target.value);
                      setIsDataChanged(true);
                    }}
                  />
                </div>
                <div className="w-full p-2 ps-0 xl:w-1/3">
                  <RadioButton
                    label={`Új bútor`}
                    id={`Újbútor`}
                    value={"Újbútor"}
                    name={`service_type`}
                    selectedOption={proposalType}
                    onChange={(e) => {
                      setProposalType(e.target.value);
                      setIsDataChanged(true);
                    }}
                  />
                </div>
                <div className="w-full p-2 ps-0 xl:w-1/3">
                  <RadioButton
                    label={`Lakás felszámolás`}
                    id={`Lakásfelszámolás`}
                    value={"Lakásfelszámolás"}
                    name={`service_type`}
                    selectedOption={proposalType}
                    onChange={(e) => {
                      setProposalType(e.target.value);
                      setIsDataChanged(true);
                    }}
                  />
                </div>
              </div>
              <ErrorLabel id={"prposalTypeError"} error={proposalTypeError} />

              <div className="mt-[3.125rem] flex flex-col flex-wrap">
                <label className="text-[1.125rem] mb-[1rem] text-text-primary-color font-bold font-lato leading-normal">
                  Feljegyzés
                </label>
                <TextArea
                  value={feljegyzes}
                  onChange={(e) => {
                    setFeljegyzes(e.target.value);
                    setIsDataChanged(true);
                  }}
                  placeholder={`Kezd el gépeni a feljegyzést...`}
                />
                <ErrorLabel id={"feljegyzesError"} error={feljegyzesError} />
              </div>
            </div>
          </div>
        </div>
      </Spinner>
    </>
  );
};

export default UjUgyfelAdatok;
